import { getResource, readUrlObjectBased } from "./api";

// Batch-hydrate promo entities (experts/products/companies) by id. The promo_entities view unifies
// the subtypes (name/slug/headline/profile_image_url) and carries `type` to tell them apart.
const getAllById = async (ids) => {
  const url = readUrlObjectBased("promo_entities", { conditionParams: { id: `in.(${ids.join(",")})` } });
  return getResource(url);
};

export default { getAllById };
